import styled from '@emotion/styled'
import {theme} from '../../core/theme'

// `hasActions` (1:Many): the summary card plus an actions footer share one
// gradient/border frame, same look as AccountSetup's StepCardWrapper around
// the catalog card + its footer.
export const SummaryWrapper = styled.div`
  background: ${theme.palette.neutral[0]};
  border: 1px solid #dde1ea;
  border-radius: 12px;
  position: sticky;
  top: 24px;
  height: 100%;
  // main (the scroller) is shorter than the viewport by the header + footer
  max-height: calc(100vh - 160px);
  overflow-y: auto;
  ${({hasActions}) =>
    hasActions &&
    `
    display: flex;
    flex-direction: column;
    background: linear-gradient(180deg, #f1f2ff 88.65%, #fdfdff 100%);
    border: 1px solid #d6def0;
    border-bottom-right-radius: 30px;
    border-bottom-left-radius: 30px;
  `}
`

// Holds the summary card. Without actions it is transparent to layout
// (display: contents), so existing callers render exactly as before.
export const SummaryBody = styled.div`
  ${({hasActions}) =>
    hasActions
      ? `
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
    border-radius: 12px;
    box-shadow: rgba(0, 0, 0, 0.07) 0px 4px 9.9px 0px;
  `
      : 'display: contents;'}
`

// Slot under the summary card inside the frame (the footer area).
export const SummaryActionsSlot = styled.div`
  flex: 0 0 auto;
  padding: 15px 20px;
`

// Covers the visible sticky area of SummaryWrapper. SummaryWrapper has
// position:sticky which establishes a containing block for position:absolute
// children. height matches max-height so the overlay fills the visible panel.
export const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: calc(100vh - 160px);
  background: rgba(255, 255, 255, 0.7);
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
`
